import firebase from 'firebase';
import { useMemo } from 'react';

export default function useFirebase() {
    const firestore = firebase.firestore();
    const storage = firebase.storage().ref();

    return useMemo(
        () => ({
            firestore,
            storage,
        }),
        [storage, firestore]
    );
}
